import script from "./UiImageSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiImageSlider.vue?vue&type=script&setup=true&lang=ts"

import "./UiImageSlider.vue?vue&type=style&index=0&id=b0dddae0&lang=scss"

const __exports__ = script;

export default __exports__